import { createContext } from 'react'

const AuthContext = createContext({
    login: () => {},
    logout: () => {},
    isloggedIn: false
});

export default AuthContext;